import React from 'react';
import { Route } from 'react-router-dom';
import ChartDashboardRoutes from './ChartDashboard/routes';
const routes = () => [<ChartDashboardRoutes key="ChartDashboardRoutes" />];

const ChartDashboardRoute = () => <Route component={routes} />;

export default ChartDashboardRoute;



// WEBPACK FOOTER //
// src/modules/screens/chartDashboard/routes.js